import React from 'react';
import Box from '@mui/material/Box';

const Container = ({ maxWidth = 1200, sx, children, ...rest }) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth,
        mx: 'auto',
        px: { xs: 3, sm: 4, md: 5 },
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Container;
